var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16732 1.3335C5.44346 1.3335 5.66732 1.55735 5.66732 1.8335V2.66683H10.0007V1.8335C10.0007 1.55735 10.2245 1.3335 10.5007 1.3335C10.7768 1.3335 11.0007 1.55735 11.0007 1.8335V2.66683H12.5007C13.5132 2.66683 14.334 3.48764 14.334 4.50016V12.5002C14.334 13.5127 13.5132 14.3335 12.5007 14.3335H3.16732C2.1548 14.3335 1.33398 13.5127 1.33398 12.5002V4.50016C1.33398 3.48764 2.1548 2.66683 3.16732 2.66683H4.66732V1.8335C4.66732 1.55735 4.89118 1.3335 5.16732 1.3335ZM4.66732 3.66683H3.16732C2.70708 3.66683 2.33398 4.03993 2.33398 4.50016V12.5002C2.33398 12.9604 2.70708 13.3335 3.16732 13.3335H12.5007C12.9609 13.3335 13.334 12.9604 13.334 12.5002V4.50016C13.334 4.03993 12.9609 3.66683 12.5007 3.66683H11.0007V4.50016C11.0007 4.77631 10.7768 5.00016 10.5007 5.00016C10.2245 5.00016 10.0007 4.77631 10.0007 4.50016V3.66683H5.66732V4.50016C5.66732 4.77631 5.44346 5.00016 5.16732 5.00016C4.89118 5.00016 4.66732 4.77631 4.66732 4.50016V3.66683ZM4.00065 7.16683C4.00065 6.89069 4.22451 6.66683 4.50065 6.66683H11.1673C11.4435 6.66683 11.6673 6.89069 11.6673 7.16683C11.6673 7.44297 11.4435 7.66683 11.1673 7.66683H4.50065C4.22451 7.66683 4.00065 7.44297 4.00065 7.16683Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCalendar);
export default __webpack_public_path__ + "static/media/small-calendar.383078dcdf7c73979879fe31d95cd020.svg";
export { ForwardRef as ReactComponent };